import { useGetUserDetailsByEmail } from '@forwardflow/hooks/customHooks/organization/useGetUserDetailsByEmail'
import LocalStorage from '@forwardflow/services/LocalStorage'
import { UserService } from '@forwardflow/services/UserService'
import { message } from 'antd'
import { useState, useEffect } from 'react'

const ROLES = ['Admin', 'Agent']

export const UserAccessPermission = ({
   email,
   userId,
}: {
   email: string
   userId: string
}) => {
   const { data: userDetails, isLoading } = useGetUserDetailsByEmail(
      email || ''
   )

   const [selectedRoles, setSelectedRoles] = useState<string[]>([])
   const [loading, setLoading] = useState(false)
   const orgId = LocalStorage.get('currentOrganization')

   // Initialize selected roles when userDetails loads
   useEffect(() => {
      if (userDetails?.roles) {
         setSelectedRoles(userDetails.roles)
      }
   }, [userDetails?.roles])

   const handleRoleChange = async (role: string) => {
      setLoading(true)
      try {
         let updatedRoles: string[]

         // Toggle role selection
         if (selectedRoles.includes(role)) {
            updatedRoles = selectedRoles.filter((r) => r !== role)
         } else {
            updatedRoles = [...selectedRoles, role]
         }

         await UserService.setUserAccessRole(
            orgId as string,
            userId as string,
            updatedRoles as any
         )

         setSelectedRoles(updatedRoles)
         message.success('User role updated successfully')
      } catch (e) {
         console.error('Failed to set user access role', e)
         message.error('Failed to update user role')
      } finally {
         setLoading(false)
      }
   }

   return (
      <div className="">
         <div className="px-10 py-5 text-xs tracking-wide text-gray-300">
            ACCESS PERMISSIONS
         </div>
         <div className="flex items-center justify-between p-6 bg-primary/10">
            <span className="pl-4 text-sm font-medium text-gray-200">
               User Role
            </span>
            <div className="flex space-x-1">
               {ROLES.map((role) => (
                  <button
                     key={role}
                     disabled={loading || isLoading}
                     onClick={() => handleRoleChange(role)}
                     className={`px-5 py-1 rounded-sm border transition-colors text-sm font-semibold
                ${
                   selectedRoles.includes(role)
                      ? 'bg-[#0FF04E]/20 text-white border-green-600'
                      : 'bg-black/10 text-gray-300 border-transparent hover:bg-black/20'
                }
                ${loading || isLoading ? 'cursor-not-allowed opacity-50' : ''}
              `}
                  >
                     {role}
                  </button>
               ))}
            </div>
         </div>
      </div>
   )
}
